<template>
  <div class="pagination">
    <div class="pagination__wrap">
      <div v-if="gridList" class="pagination__inner-wrap">
        <div class="pagination__grid" :class="grid">
          <svg @click="setGrid('')">
            <use xlink:href="#icon-th-solid"></use>
          </svg>
          <svg @click="setGrid('cards')">
            <use xlink:href="#icon-th-large-solid"></use>
          </svg>
        </div>
        <form class="category-page__form">
          <select
            @change="setSortProducts"
            v-model="sortBy"
            class="category-page__select"
          >
            <option value="new_arrivals">Most Recent</option>
            <option value="oldest">Oldest</option>    
          </select>
        </form>
      </div>

      <div v-else class="pagination__btn-wrap">
        <div
          @click="next"
          class="pagination__next"
          :class="{ disable: page === maxPage }"
        >
          Next
          <svg>
            <use xlink:href="#icon-caret-right-solid"></use>
          </svg>
        </div>
        <p class="main-text">
          Total Found: <strong>{{ filterProds.length }}</strong>
        </p>
      </div>

      <div class="pagination__input-wrap">
        <svg @click="prev">
          <use xlink:href="#icon-chevron-left-light"></use>
        </svg>
        <input
          type="number"
          min="1"
          :max="maxPage"
          v-model="current"
          class="pagination__input"
        />
        <svg @click="next">
          <use xlink:href="#icon-chevron-right-light"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Pagination",
  props: ["gridList"],
  data() {
    return {
      sortBy: "new_arrivals",
    };
  },
  computed: {
    ...mapState("products", ["page", "maxPage", "filterProds", "grid"]),
    current: {
      get() {
        return this.page;
      },
      set(v) {
        this.setPage(v);
      },
    },
  },
  methods: {
    ...mapMutations("products", ["setPage", "setGrid", "sortProducts"]),
    setSortProducts() {
      this.sortProducts(this.sortBy);
    },
    next() {
      const page = this.page + 1;
      this.setPage(page);
    },
    prev() {
      const page = this.page - 1;
      this.setPage(page);
    },
  },
  mounted() {},
};
</script>
